/*
 * Control behavior of testimonials on the home page as well as the side bar.
 */
var TestimonialController = (function ($) {
	
    var win, body, timeout, sharedTestimonialId,
		resetStyles = {position: '', display: '', left: '', right: ''};
	
	function ready() {
		win = $(window);
		body = $(document.body);
		
        if (document.body.classList.contains("home")) {
            body.on('click', '.testimonials .prev', onHomePrevClick);
            body.on('click', '.testimonials .next', onHomeNextClick);
        }
        else {
            body.on('click', '.testimonials .prev', onAsidePrevClick);
            body.on('click', '.testimonials .next', onAsideNextClick);
        }
		
        if (!body.hasClass('home')) {
			if ($("html").hasClass("lt-ie9")) {
				$(".testimonials").addClass("testimonials-not-home");
			}
		}
        win.on('load', resizeTestimonials);
        win.on('resize', resizeTestimonials);

		sharedTestimonialId = getUrlParameter('tid');
		if (sharedTestimonialId !== '') {
		    sharedTestimonialId = sharedTestimonialId.replace('{', '').replace('}', '');
		    setSharedTestimonial(sharedTestimonialId);
		}
	}

    function resizeTestimonials() {
        clearTimeout(timeout);
        var childSelector = body.hasClass('home') ? '.item' : 'div';
        timeout = setTimeout(function () {
            GridController.equalizeHeights($(".testimonials").children(childSelector));	
		}, 44);
	}

	function onHomePrevClick(e) {
		e.preventDefault();
		var clicked = $(e.target), 
				items = clicked.closest('.testimonials').children('.item');
		movePrev(items, '.item');
	}
	function onHomeNextClick(e) {
		e.preventDefault();
		var clicked = $(e.target), 
				items = clicked.closest('.testimonials').children('.item');
		moveNext(items, '.item');
	}
	function onAsidePrevClick(e) {
		e.preventDefault();
		var clicked = $(e.target), 
				items = clicked.closest('.testimonials').children('div');
		movePrev(items);
	}
	function onAsideNextClick(e) {
		e.preventDefault();
		var clicked = $(e.target), 
				items = clicked.closest('.testimonials').children('div');
		moveNext(items);
	}
	
	function movePrev(items, itemSelector) {
		itemSelector = itemSelector || 'div';
		items.css(resetStyles);
		var active = items.filter('.active');
		var prev = active.prev(itemSelector);
		if (prev.length === 0) {
			prev = items.last(itemSelector);
		}
		if (prev.length > 0) {
			active.removeClass('active');
            prev.css({ display: 'block', position: 'relative', left: 'auto', right: '20px' });
            resizeTestimonials();
			prev.stop(true, false).animate({right: 0}, 750, 'easeOutQuart', function () {
                prev.css(resetStyles);
			});
			prev.addClass('active');
			if (typeof GridController !== 'undefined') {
				GridController.equalizeGrids();
			}
		}
	}
	
	function moveNext(items, itemSelector) {
		itemSelector = itemSelector || 'div';
		items.css(resetStyles);
		var active = items.filter('.active');
		var next = active.next(itemSelector);
		if (next.length === 0) {
			next = items.first(itemSelector);
		}
		if (next.length > 0) {
			active.removeClass('active');
            next.css({ display: 'block', position: 'relative', left: '20px' });
            resizeTestimonials();
			next.stop(true, false).animate({ left: 0 }, 750, 'easeOutQuart', function () {
                next.css(resetStyles);
			});
			next.addClass('active');
			if (typeof GridController !== 'undefined') {
				GridController.equalizeGrids();
			}
		}
	}
	

	function setSharedTestimonial(testimonialId) {
	    if ($("div.testimonials div[data-tid*='" + testimonialId.toUpperCase() + "']").length > 0) {
	        $('div.testimonials div.active').removeClass('active');
	        var sharedTestimonial = $("div.testimonials div[data-tid*='" + testimonialId.toUpperCase() + "']").first();
	        $(sharedTestimonial).addClass('active');
	        var testimonialLink = $(sharedTestimonial).find('a.modal-trigger');
            //if (typeof(MouseEvent) === 'function') {
                var event = new MouseEvent('click', {
                    'view': window,
                    'bubbles': true,
                    'cancelable': true
                });
                $(testimonialLink)[0].dispatchEvent(event);
            //}
	    }
	}

	function getUrlParameter(sParam) {
	    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

	    for (i = 0; i < sURLVariables.length; i++) {
	        sParameterName = sURLVariables[i].split('=');

	        if (sParameterName[0] === sParam) {
	            return sParameterName[1] === undefined ? true : sParameterName[1];
	        }
	    }
	    return '';
	}

	$(ready);
	
})(jQuery);